export default __webpack_public_path__ + "static/media/maam.4a3ef96f.jpg";